import { render, staticRenderFns } from "./user-view.vue?vue&type=template&id=a5081b7c&"
import script from "./user-view.vue?vue&type=script&lang=js&"
export * from "./user-view.vue?vue&type=script&lang=js&"
import style0 from "./user-view.vue?vue&type=style&index=0&id=a5081b7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports